import React from "react";
import { Mui } from "@osu/react-ui";
import { EXTERNAL_LINK_DESCRIPTOR } from "../../util/constants";

export default function ExternalLink(props = {}) {
    return (<Mui.Link aria-describedby={EXTERNAL_LINK_DESCRIPTOR} target="_blank" rel="noopener" {...props}></Mui.Link>);
}